import { aabbOverlap, moveAndCollide, type AABB } from '../../engine/Physics';
import { Enemy, type EnemyContext } from './Enemy';
import type { EnemyDef } from '../../types';

const TERMINAL_VY = 18;

export class Onion extends Enemy {
  override width = 32;
  override height = 32;
  vx: number;
  vy = 0;
  private originX: number;
  private range: number;
  private onGround = false;

  constructor(def: EnemyDef) {
    super(def);
    this.originX = def.x;
    this.range = def.patrolRange ?? 96;
    const speed = def.speed ?? 2;
    this.vx = speed;
    this.draw();
  }

  private draw(): void {
    const g = this.gfx;
    g.clear();
    g.circle(0, -2, 14)
      .fill({ color: 0xe0c060 })
      .stroke({ color: 0x000000, width: 2 });
    g.poly([-3, -16, 3, -16, 0, -22])
      .fill({ color: 0x6abf6a })
      .stroke({ color: 0x000000, width: 2 });
    g.circle(-5, -3, 2.5).fill({ color: 0x000000 });
    g.circle(5, -3, 2.5).fill({ color: 0x000000 });
    g.poly([-9, -7, -3, -2, -9, -2]).fill({ color: 0x000000 });
    g.poly([3, -2, 9, -7, 9, -2]).fill({ color: 0x000000 });
    g.ellipse(-7, 5, 1.5, 3).fill({ color: 0x4ab7ff });
    g.ellipse(7, 5, 1.5, 3).fill({ color: 0x4ab7ff });
  }

  override step(ctx: EnemyContext): void {
    if (!this.alive) return;

    this.vy += ctx.cfg.gravity;
    if (this.vy > TERMINAL_VY) this.vy = TERMINAL_VY;

    if (this.onGround) {
      const probeX = this.vx > 0 ? this.x + this.width + 1 : this.x - 1;
      const probe: AABB = { x: probeX - 0.5, y: this.y + this.height + 2, w: 1, h: 1 };
      let supported = false;
      for (const s of ctx.solids) {
        if (aabbOverlap(probe, s)) {
          supported = true;
          break;
        }
      }
      if (!supported) this.vx = -this.vx;
    }

    const box = this.bounds();
    const res = moveAndCollide(box, this.vx, this.vy, ctx.solids);
    this.x = box.x;
    this.y = box.y;

    if (res.hitY) {
      const wasFalling = this.vy > 0;
      this.vy = 0;
      if (wasFalling) this.onGround = true;
    } else {
      this.onGround = false;
    }
    if (res.hitX) this.vx = -this.vx;

    if (this.x <= this.originX - this.range) {
      this.x = this.originX - this.range;
      this.vx = Math.abs(this.vx);
    } else if (this.x >= this.originX + this.range) {
      this.x = this.originX + this.range;
      this.vx = -Math.abs(this.vx);
    }

    this.gfx.scale.x = this.vx >= 0 ? 1 : -1;
  }
}
